import { useMutation, useQuery, useQueryClient } from "react-query";
import { http } from "src/api/http";
import { Customer, CustomerDetails, CxActivity } from './models';

export function useHqCustomersAPI() {
  return useQuery<Customer[]>({
    queryKey: ["useHqCustomers"],
    queryFn: () => http(`/api/hq/customers`)
  });
}

export function useCustomersDetailsAPI(id: string) {
  return useQuery<CustomerDetails>({
    queryKey: ["useHqCustomerDetails"],
    queryFn: () => http(`/api/hq/customers/${id}`)
  });
}

export function useHqCustomersUpdateMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: Partial<CustomerDetails>) => http(`/api/hq/customers`, {
      method: 'PUT',
      body,
    }),
    onSuccess: () => {
      queryClient.invalidateQueries(['useHqCustomerDetails']);
    }
  });
}

export function useGetCustomerCxActivitiesAPI(id: string) {
  return useQuery<CxActivity[]>({
    queryKey: ["useGetCustomerCxActivities"],
    queryFn: () => http(`/api/hq/customers/${id}/cx-activities`)
  });
}

export function usePutCustomerCxActivitiesAPI(id: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: (Omit<CxActivity, 'date'> & { date: string; })[]) => http(`/api/hq/customers/${id}/cx-activities`, {
      method: 'PUT',
      body,
    }),
    onSuccess: () => {
      queryClient.invalidateQueries(['useGetCustomerCxActivities']);
    }
  });
}